

export const error = (state = {}, action) => {
    const { error } = action.payload;
    if (!error) {
        return state;
    }
    const modelState = error.modelState || error.ModelState;
    if (modelState) {
        return modelState;
    }
    if (error.name === 'ValidationError') {
        return {
            [error.path]: error.errors,
        };
    }
    return state;
}